import type { AppLanguage } from "../../constants/dashboard-language";

type LanguageToggleButtonProps = {
  language: AppLanguage;
  onChangeLanguage: (next: AppLanguage) => void;
  className?: string;
  compact?: boolean;
};

export default function LanguageToggleButton({
  language,
  onChangeLanguage,
  className,
  compact = false,
}: LanguageToggleButtonProps) {
  const isEnglish = language === "en";
  const nextLanguageLabel = isEnglish ? "Switch to Khmer" : "Switch to English";
  return (
    <button
      type="button"
      data-tab-trigger="true"
      onClick={() => onChangeLanguage(isEnglish ? "kh" : "en")}
      className={
        className ??
        "rounded-full border border-[color:var(--field-border)] bg-[color:var(--card)] px-3 py-2 text-xs font-semibold uppercase tracking-widest text-[color:var(--foreground)] transition hover:bg-[color:var(--surface-hover)]"
      }
      aria-label={nextLanguageLabel}
      title={nextLanguageLabel}
    >
      {compact ? (
        <span className="inline-flex items-center justify-center" aria-hidden="true">
          {isEnglish ? "🇺🇸" : "🇰🇭"}
        </span>
      ) : (
        <span className="inline-flex items-center gap-1.5">
          <span aria-hidden="true">{isEnglish ? "🇺🇸" : "🇰🇭"}</span>
          <span>{isEnglish ? "EN" : "KH"}</span>
        </span>
      )}
    </button>
  );
}
